import './assets/main.css';

import { createApp } from 'vue';
import App from './App.vue';
import 'toastify-js/src/toastify.css';

import Toastify from 'toastify-js';

const app = createApp(App);

app.config.globalProperties.$showToast = (text, success = true) => {
    Toastify({
        text: text,
        gravity: window.innerWidth < 1024 ? 'top' : 'bottom',
        duration: 2000,
        stopOnFocus: false,
        style: {
            background: success ? "#3ECB00" : "#CB0037"
        }
    }).showToast();
};

app.mount('#app');